"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-bold", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
            _react2.default.createElement("path", { d: "M14 11h4.46c.68 0 1.31.05 1.89.15.58.1 1.087.277 1.52.53.433.253.773.587 1.02 1 .247.413.37.933.37 1.56 0 .293-.043.587-.13.88a2.744 2.744 0 0 1-1.07 1.5c-.28.2-.607.347-.98.44v.08c.933.173 1.637.507 2.11 1 .473.493.71 1.18.71 2.06 0 .667-.13 1.24-.39 1.72s-.62.877-1.08 1.19c-.46.313-.997.547-1.61.7a8.146 8.146 0 0 1-1.98.23H14V11zm4.32 5.26c.72 0 1.243-.143 1.57-.43.327-.287.49-.677.49-1.17 0-.493-.167-.847-.5-1.06-.333-.213-.847-.32-1.54-.32h-1.4v2.98h1.38zm.28 5.5c1.613 0 2.42-.593 2.42-1.78 0-.573-.2-.99-.6-1.25-.4-.26-1.007-.39-1.82-.39h-1.66v3.42h1.66z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-bold.js
// module id = 1833
// module chunks = 0